module.exports = __webpack_public_path__ + "static/img/arrow.2548b39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qcwy/images/arrow.png
// module id = 03Px
// module chunks = 1